import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      //height: '100vh', 
      //backgroundColor: '#0D0D0D', // Derin Siyah
      color: '#FFFFFF', 
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{ 
        fontSize: '6rem', 
        fontWeight: 'bold', 
        margin: '0',
        color: '#F28C38' // Turuncu Vurgu Rengi
      }}>
        404
      </h1>
      <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>
        Sayfa Bulunamadı
      </h2>
      <p style={{ color: '#888888', marginBottom: '30px', maxWidth: '400px' }}>
        Aradığınız sayfa silinmiş, adı değiştirilmiş veya geçici olarak kullanım dışı olabilir.
      </p>
      
      <Link to="/" style={{
        backgroundColor: '#FFFFFF',
        color: '#0D0D0D',
        padding: '12px 24px',
        borderRadius: '30px', // Ultra Yuvarlak Köşe
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: '1rem',
        transition: 'opacity 0.3s'
      }}
      onMouseOver={(e) => e.target.style.opacity = '0.8'}
      onMouseOut={(e) => e.target.style.opacity = '1'}
      >
        Ana Sayfaya Dön
      </Link>
    </div>
  );
}